// extracted by mini-css-extract-plugin
module.exports = {"emojiWrapper":"Emoji_emojiWrapper__EhW9K"};